import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-oro bg-noche text-white" data-id="element-94" data-mp="9lbg511q9bdl">
      <div className="mx-auto max-w-2xl px-3 pb-4 pt-3 text-center sm:px-5" data-id="element-95" data-mp="4mi319qcrmdy">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[2rem] uppercase leading-[1.05] tracking-wide text-white sm:text-5xl" data-id="element-96" data-mp="1297cg4ndx19u">
          El sistema completo para aprender{' '}
          <span className="text-oro" data-id="element-97" data-mp="nczrh245jvti">química</span>{' '}
          <span className="bg-oro px-1.5 text-noche" data-id="element-98" data-mp="nekm0rqgverd">desde cero hasta avanzado</span>
        </motion.h1>

        <p className="mt-2 font-sub text-sm font-extrabold uppercase leading-tight tracking-wide text-ciencia" data-id="element-99" data-mp="382fern45x2ee">
          Método de aprendizaje paso a paso
        </p>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/85" data-id="element-100" data-mp="3j9ainhg5sy79">
          Aprende química con un sistema organizado, comprende las fórmulas,
          resuelve ejercicios y prepárate para estudiar, rendir exámenes o
          enseñar con mayor seguridad —{' '}
          <strong className="font-bold text-oro" data-id="element-101" data-mp="3599k48nda2uy">
            sin perderte entre cientos de apuntes, videos y explicaciones
            difíciles.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg border-2 border-ciencia bg-noche-light px-3 py-1.5 font-sub text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-102" data-mp="2viomanfip2d3">
          {PRODUCT_NAME} · <span className="text-oro" data-id="element-103" data-mp="2lla9cxssyvpj">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-oro bg-white" data-id="element-104" data-mp="s21gq7e3o5xv">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-105" data-mp="ddf3qcby3q9t" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-bold leading-snug text-white/85 sm:text-sm" data-id="element-106" data-mp="1ayjep6jjl22k">
          {PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos
        </p>

        <div className="mt-2.5" data-id="element-107" data-mp="110wohnwslo3a">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-108" data-mp="x14npxdn4m8h">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-white/80" data-id="element-109" data-mp="3ltgm7o0v2mna">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}